// Characters served by this React app itself (public/characters/<Name>/...), shown first in the
// Characters panel's "Talking" tab. Used to try new characters on localhost before they are
// uploaded to the library with the admin upload.
//
// Each character has four actions: <Name>_Default/Talking/Wave/Walk.json, with a picture of the
// same name (.png). All of them have a talking mouth (Mouth_Talk), so they move their mouth while
// their voice plays.
//
// Note: the export server cannot reach these files on localhost, so an exported video uses the
// character as saved in the project; a walk action on a move needs the library version.

// Men are served from characters/Male/<Name>: the app tells a character's gender by "Male" in its
// file address (the voice gender, for example).
const LOCAL_CHARACTERS = [
  { name: "Maya" },
  { name: "Omar", male: true },
  { name: "Aisha" },
  { name: "Leo", male: true },
  { name: "Zara" },
  { name: "Ken", male: true },
  { name: "Lina" },
];
const ACTIONS = ["Default", "Talking", "Wave", "Walk"];

const base = () => window.location.origin + (process.env.PUBLIC_URL || "");

const localCharacter = ({ name, male }) => {
  const dir = base() + "/characters/" + (male ? "Male/" : "") + name + "/";
  const pose = (type) => ({ type, jsonPath: dir + name + "_" + type + ".json", imgPath: dir + name + "_" + type + ".png" });
  return {
    Id: "local-" + name.toLowerCase(),
    CategoryId: 3,
    Name: name,
    DefaultPath: dir + name + "_Default.json",
    PreviewPath: dir + name + "_Default.png",
    GesturePaths: JSON.stringify(ACTIONS.map(pose)),
    isLocal: true,
    talks: true, // has a talking mouth (Mouth_Talk): listed in the Talking tab
  };
};

/** The server's character rows with the local characters added at the front. */
export function withLocalCharacters(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const have = new Set(list.map((r) => r && r.Id));
  const local = LOCAL_CHARACTERS.map(localCharacter).filter((c) => !have.has(c.Id));
  return local.concat(list);
}
